(function() {
  var countdownSections = document.querySelectorAll('#countdown-banner-section');

  countdownSections.forEach(function(sectionElCustom) {
    var endTimeRawCustom = sectionElCustom.dataset.endTime;
    if (!endTimeRawCustom) return;

    var isoStringCustom = endTimeRawCustom.replace(' ', 'T');
    var endTimeCustom = new Date(isoStringCustom).getTime();

    var dayElCustom = sectionElCustom.querySelector('.countdown-day-custom');
    var hourElCustom = sectionElCustom.querySelector('.countdown-hour-custom');
    var minuteElCustom = sectionElCustom.querySelector('.countdown-minute-custom');
    var secondElCustom = sectionElCustom.querySelector('.countdown-second-custom');
    var messageElCustom = sectionElCustom.querySelector('#countdown-message-custom');

    function updateCountdown() {
      var now = Date.now();
      var diff = endTimeCustom - now;

      if (diff <= 0) {
        clearInterval(interval);
        sectionElCustom.querySelector('.countdown-banner__text-custom').style.display = 'none';
        sectionElCustom.querySelector('.countdown-banner__timer-custom').style.display = 'none';
        messageElCustom.style.display = 'block';
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      dayElCustom.textContent = String(days).padStart(2, '0');
      hourElCustom.textContent = String(hours).padStart(2, '0');
      minuteElCustom.textContent = String(minutes).padStart(2, '0');
      secondElCustom.textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();

    var interval = setInterval(updateCountdown, 1000);
  });
})();
